import {Store} from 'effector'
import {h, spec} from 'forest'
import {CELL} from './env'

export function dot({
  pos,
  color,
  tag
}: {
  pos: Store<{x: number; y: number}>
  color: Store<string>
  tag: Store<string>
}) {
  const translate = pos.map(({x, y}) => `translate(${x * CELL} ${y * CELL})`)
  h('g', {
    attr: {
      transform: translate
    },
    data: {tag},
    fn() {
      h('circle', {
        attr: {
          cx: 0.5 * CELL,
          cy: 0.5 * CELL,
          r: 6,
          fill: color
        }
      })
    }
  })
}
